import { ComponentType, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '../hooks/store';
import { selectIsAuthorized } from '@/store/slices/auth/selectors';
import { getDefaultRoute } from '../helpers/route';

export const unauthorized =
  <TProps extends object>(Page: ComponentType<TProps>) =>
    (props: TProps) => {
      const isAuthorized = useAppSelector(selectIsAuthorized);

      const navigate = useNavigate();

      useEffect(() => {
        if (isAuthorized) {
          const redirectTo = sessionStorage.getItem("redirectAfterLogin") || "";
          sessionStorage.removeItem("redirectAfterLogin");
          setTimeout(navigate, 0, redirectTo || getDefaultRoute());
        } // this will take over and take the user to / if the yare authorized
      }, [isAuthorized, navigate]);

      return !isAuthorized ? <Page {...props} /> : null; // if not authorized we are allowed to render the current route
    };
